import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import Card from '../Card';

export default function Index({ plans }) {
  return (
    <Row>
      {plans.map((plan) => (
        <Col key={plan.id} lg="6">
          <Card plan={plan} />
        </Col>
      ))}
    </Row>
  );
}

Index.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};
